import axios from "@/api/axiosInstance";
import { FetchTrainingHistoryReportParams } from "./types";

export const fetchTrainingHistoryReportCsv = async (
  params: Omit<FetchTrainingHistoryReportParams, "page" | "pageSize"> = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/reports/training-history/export",
    { responseType: "blob", params },
  );
  return response.data;
};
